module.exports = __webpack_public_path__ + "media/images/failure-2-5d2170d42ba2573f041b0e6681411fce.png";